import React from 'react'
import HotelIcon from '@mui/icons-material/Hotel'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'

import FlightIcon from '@/src/assets/svgs/FlightIcon'
import FlightPlusHotelIcon from '@/src/assets/svgs/FlightPlusHotelIcon'

import { ToolbarLink, ToolbarPathMap } from '@/src/types/bottomToolbar'

// Note: Labels are translation keys, not actual text
// They will be translated in the component using useTranslations('common')
export const TOOLBAR_LINKS: ToolbarLink[] = [
    {
        label: 'flight',
        value: 'flight',
        icon: React.createElement(FlightIcon)
    },
    {
        label: 'hotel',
        value: 'hotel',
        icon: React.createElement(HotelIcon)
    },
    {
        label: 'flightPlusHotel',
        value: 'fph',
        icon: React.createElement(FlightPlusHotelIcon)
    },
    {
        label: 'offers',
        value: 'offers',
        icon: React.createElement(LocalOfferOutlinedIcon)
    },
    {
        label: 'account',
        value: 'account',
        icon: React.createElement(AccountCircleOutlinedIcon)
    }
]

export const TOOLBAR_PATH_MAP: ToolbarPathMap = {
    flight: '/',
    hotel: '/hotels',
    fph: '/fph',
    offers: '/offers',
    account: '/account'
}
